import { render, staticRenderFns } from "./RondoGameOver.vue?vue&type=template&id=dacfb84e&scoped=true&"
import script from "./RondoGameOver.vue?vue&type=script&lang=js&"
export * from "./RondoGameOver.vue?vue&type=script&lang=js&"
import style0 from "./RondoGameOver.vue?vue&type=style&index=0&id=dacfb84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacfb84e",
  null
  
)

export default component.exports